import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Button } from '@material-ui/core';

function Copyright() {
  return (
    <Typography variant="body1" align="center">
      {'© '}
      {' Sampathkumar Veeraraghavan for HKN President 2022'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // minHeight: '100vh',
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    color: "#f5f5f5",
    backgroundColor:
      theme.palette.type === 'light'
        ? "#005e97"
        : theme.palette.grey[800],
  },
  // footer: {
  //   padding: theme.spacing(3, 2),
  //   marginTop: 'auto',
  //   backgroundColor:
  //     theme.palette.type === 'light'
  //       ? theme.palette.grey[300]
  //       : theme.palette.grey[900],
  // },
}));

export function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* <footer className={classes.footer1} style={{ padding: '40px' }}>
        <Container maxWidth="sm">
          <Button variant="contained">Contact me</Button>
          <Typography variant="h6" align="center">
            Sampath for HKN
          </Typography>
        </Container>
      </footer> */}
      <footer className={classes.footer} style={{ padding: '10px' }}>
        <Container maxWidth="md">
          <Typography variant="body1" align="center">
            All opinions expressed are the authors and not necessarily the
            opinions of the IEEE.
          </Typography>
          <Copyright />
        </Container>
      </footer>
    </div>
  );
}
